import './index.css';
import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import FrontPage from './FrontPage.jsx';
import Blog from './Blog.jsx';
import Admin from './Admin.jsx';
import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import { setContext } from '@apollo/client/link/context';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ApolloClient, InMemoryCache, ApolloProvider, createHttpLink} from "@apollo/client";


const App = () => {
  const [token, setToken] = useState('');

  const httpLink = new createHttpLink ({
      uri: 'https://2fivefive-blog.hasura.app/v1/graphql',
  });

  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const getToken = getAccessTokenSilently;

  if (isAuthenticated) {
    getToken().then(value => setToken(value));
  }

  const authLink = setContext((_,{headers}) => {
    const authHeaders = {
      headers: {
        ...headers,
        authorization: `Bearer ${token}`,
      }
    }
    return isAuthenticated ? authHeaders : headers;

  });

  const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
  });

  return(
      <React.StrictMode>
          <ApolloProvider client={client}>
              <BrowserRouter basename="/">
                  <Routes>
                      <Route path="/" element={<FrontPage />} />
                      <Route path="blog" element={<Blog />} />
                      <Route path="admin" element={<Admin />} />
                  </Routes>
              </BrowserRouter>

          </ApolloProvider>
      </React.StrictMode>
  );
}

ReactDOM.render(
    <Auth0Provider
        domain="dev-sts0vub3.us.auth0.com"
        clientId="xrFY0cgf4xZuqk6gpy8V7y7PHJ8LwHoL"
        redirectUri={window.location.href}
        audience="https://2fivefive.xyz/blog"
    >
      <App />
    </Auth0Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
